import { createSelector } from 'reselect';

import {
  selectBasketIsGRActive,
  selectBasketItemsEntityIsGRActive,
  selectBasketMode,
  selectBasketStatus,
} from '../../../../selectors/basket/basketPrimary.selector';
import { StateType } from '../../../../states';
import { BasketModes, BasketStatuses } from '../../../../types/basket';
import { GRAssetsBySkinId } from '../../constants/assets';
import { getGRLabelsBySkinId } from '../../constants/labels';
import { selectGRGlobalSkinId } from '../../selectors/global/globalPrimary.selector';

type EntitiesBetslipsSelectorProps = {
  oddId?: number;
};

const selectGRBasketBetslipHeadbandProps = () => {
  const selectBandVisible = (state: StateType, props: EntitiesBetslipsSelectorProps) => {
    const oddId = props.oddId;
    const basketStatus = selectBasketStatus(state);
    const basketMode = selectBasketMode(state);
    const basketIsGRActive = selectBasketIsGRActive(state);
    const basketItemIsGRActive = selectBasketItemsEntityIsGRActive(state, props);

    if (basketMode === BasketModes.SIMPLE && basketStatus === BasketStatuses.VALIDATED) {
      return (oddId && basketItemIsGRActive) as boolean;
    }

    if (basketMode === BasketModes.COMBINED && basketStatus === BasketStatuses.VALIDATED) {
      return (!oddId && basketIsGRActive) as boolean;
    }

    return false;
  };

  const selectLabel = createSelector([selectGRGlobalSkinId], (skinId) => {
    if (!skinId) {
      return '';
    }

    return getGRLabelsBySkinId(skinId)?.OperationTitle;
  });

  const selectIcon = (state: StateType) => {
    const skinId = selectGRGlobalSkinId(state);

    if (!skinId) {
      return '';
    }

    return GRAssetsBySkinId[skinId]?.IconPath;
  };

  return createSelector([selectBandVisible, selectLabel, selectIcon], (isVisible, label, icon) => {
    return {
      label,
      icon,
      isVisible,
    };
  });
};

export default selectGRBasketBetslipHeadbandProps;
